import React, { useState, useEffect } from 'react';
import logoblack from '../../images/lineageblacklogo.png';
import givepageimage from '../../images/givepage/giveimageflip.png';
import doddleImage from '../../images/givepage/doddle.png';
import doddleText from '../../images/givepage/doddle.svg';
import EmailReminderModal from './remainder';
import { PopupfaqItems } from './faqdata';
import FAQTooltip from './faq-popup';
import { Link } from '@reach/router';
import { YOUTUBE_VIDEO_URL, YOUTUBE_VIDEO_ID, getYouTubeEmbedUrl } from '../../utils/constants';
import { navigate } from 'gatsby';
import DonorboxForm from '../NewGive/DonorForm';
import { LJCampaignUrl } from '../../constants/donorboxcampaign';

const DonationPopup = ({ isOpen, onClose, onDonationComplete }) => {
  const [showReminder, setReminder] = useState(false);
  const [showFAQTooltip, setShowFAQTooltip] = useState(false);
  const [selectedFAQ, setSelectedFAQ] = useState(null);
  const [triggerElement, setTriggerElement] = useState(null);
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  // Listen for messages from Donorbox iframe
  useEffect(() => {
    const handleMessage = (event) => {
      if (event.origin !== 'https://donorbox.org') return;

      try {
        const data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
        console.log(data);

        // Donorbox sends payment_complete event with donation details
        if (data.event === 'payment_complete' || data.event === 'donation_complete') {
          const donationAmount = parseFloat(data.amount || data.donation_amount || 0);

          if (donationAmount > 0 && onDonationComplete) {
            onDonationComplete(donationAmount);
            setTimeout(() => {
              onClose();
            }, 2000);
          }
        }
      } catch (error) {
        console.error('Error parsing Donorbox message:', error);
      }
    };

    if (typeof window !== 'undefined') {
      window.addEventListener('message', handleMessage);

      return () => {
        window.removeEventListener('message', handleMessage);
      };
    }
  }, [onDonationComplete, onClose]);

  // Reset video playing state when popup opens/closes
  useEffect(() => {
    if (isOpen) {
      setIsVideoPlaying(false);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleFAQClick = (faq, event) => {
    const target = event.currentTarget;
    setTriggerElement(target);
    setSelectedFAQ(faq);
    setShowFAQTooltip(true);
  };

  const handleFAQSelect = (faq) => {
    setSelectedFAQ(faq);
  };

  const closeFAQTooltip = () => {
    setShowFAQTooltip(false);
    setSelectedFAQ(null);
    setTriggerElement(null);
  };

  const handleVideoPlay = () => {
    setIsVideoPlaying(true);
  };

  const handleGive = (link) => {
    if (link === 'mail-a-donation') {
      navigate('/give#faq');
    } else {
      navigate('/give');
    }
    onClose();
  };

  const handleFaq = () => {
    navigate('/faq');
    onClose();
  };

  return (
    <div className="donation-popup-overlay">
      <div className="donation-popup-container">
        <div className="donation-popup">
          {/* Doodle */}
          {!showReminder && (
            <div className="donation-popup__handwritten-note">
              <img src={doddleText} alt="The most effective way to support the cause" className="handwritten-text" />
              <img src={doddleImage} alt="" className="handwritten-doodle" />
            </div>
          )}

          <button
            className="donation-popup__close"
            onClick={() => {
              if (!showReminder) {
                setReminder(true);
              } else {
                setReminder(false);
                onClose();
                navigate('/give');
              }
            }}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M18 6L6 18M6 6L18 18"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>

          <div className="donation-popup__content">
            <div className="donation-popup__content-inner">
                  {/* Left Side */}
                  <div className="donation-popup__left">
                    <div
                      className="donation-popup__video-container"
                      style={{
                        position: 'relative',
                        height: '400px',
                        width: '100%',
                        overflow: 'hidden',
                      }}
                    >
                      {isVideoPlaying ? (
                        <iframe
                          className="donation-popup__video"
                          width="100%"
                          height="100%"
                          src={getYouTubeEmbedUrl(YOUTUBE_VIDEO_ID, {
                            autoplay: 1,
                            mute: 0,
                            loop: 1,
                            controls: 0,
                            showinfo: 0,
                            rel: 0,
                            modestbranding: 1,
                          })}
                          title="YouTube video player"
                          frameBorder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                          allowFullScreen
                          style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            border: 'none',
                            zIndex: 1,
                          }}
                        />
                      ) : (
                        <img
                          className="donation-popup__video"
                          src={givepageimage}
                          alt="Lineage Journey"
                          style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            zIndex: 1,
                          }}
                        />
                      )}

                      {!isVideoPlaying && (
                        <div
                          className="donation-popup__play-button"
                          onClick={handleVideoPlay}
                          style={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            zIndex: 2,
                            cursor: 'pointer',
                          }}
                        >
                          <svg width="60" height="60" viewBox="0 0 60 60" fill="none">
                            <circle cx="30" cy="30" r="30" fill="rgba(255,255,255,0.9)" />
                            <path d="M23 20L40 30L23 40V20Z" fill="#333" />
                          </svg>
                        </div>
                      )}
                    </div>

                    <div className="donation-popup__info">
                      <div className="donation-popup__logo">
                        <img src={logoblack} alt="Lineage logo black" />
                      </div>

                      <h3 className="donation-popup__title">On This Journey Together</h3>

                      <p className="donation-popup__description">
                        Lineage Journey is a coordinated project and your support helps people discover their identity,
                        understand their purpose and realize their destiny.
                      </p>

                      <div className="donation-popup__buttons">
                        <div
                          onClick={handleGive}
                          target="_blank"
                          className="donation-popup__btn donation-popup__btn--primary"
                        >
                          Other Ways to Give
                        </div>
                        <div
                          onClick={() => handleGive('mail-a-donation')}
                          target="_blank"
                          className="donation-popup__btn donation-popup__btn--secondary"
                        >
                          Mail a Donation
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Right Side */}
                  {showReminder ? (
                    <>
                      <div
                        className="donation-popup__right"
                        style={{
                          position: 'relative',
                          animation: 'slideInFromRight 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                        }}
                      >
                        <div className="donation-popup__form-container">
                          <EmailReminderModal setReminder={setReminder} onClose={onClose} />
                        </div>
                      </div>
                      <style>
                        {`
                        @keyframes slideInFromRight {
                          from {
                            transform: translateX(100%);
                            opacity: 0;
                          }
                          to {
                            transform: translateX(0);
                            opacity: 1;
                          }
                        }
                      `}
                      </style>
                    </>
                  ) : (
                    <div className="donation-popup__right">
                      <div className="donation-popup__form-container">
                        <div className="donorbox-embed-placeholder">
                          <DonorboxForm
                            embedCode={LJCampaignUrl}
                            width="100%"
                            resizeWhenVisible={isOpen}
                          />
                        </div>
                      </div>
                      <div className="donation-popup__faq-footer">
                        <div onClick={handleFaq}>
                          <p className="donation-popup__form-text">
                            Have questions? Want to give with a check? <br />
                            Visit our FAQ.
                          </p>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                <div
                  style={{
                    position: 'relative',
                  }}
                  className="donation-popup__footer-text "
                >
                  {PopupfaqItems.map((item, idx) => (
                    <div
                      key={idx}
                      className={`donation-popup__btn--secondary  ${
                        idx === PopupfaqItems.length - 1 ? 'last-mobile-item' : ''
                      }`}
                    >
                      <button onClick={(event) => handleFAQClick(item, event)} className="donation-popup__btn">
                        {item.question}
                      </button>
                      {(() => {
                        if (typeof window !== 'undefined' && window.matchMedia('(max-width: 1024px)').matches) {
                          return idx !== PopupfaqItems.length - 1 && idx !== PopupfaqItems.length - 2 ? <hr /> : null;
                        }
                        return idx !== PopupfaqItems.length - 1 ? <hr /> : null;
                      })()}
                    </div>
                  ))}
                  <div>
                    <FAQTooltip
                      isOpen={showFAQTooltip}
                      faqItem={selectedFAQ}
                      onClose={closeFAQTooltip}
                      allFAQs={PopupfaqItems}
                      onFAQSelect={handleFAQSelect}
                      triggerElement={triggerElement}
                    />
                  </div>
                </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DonationPopup;
